export default __webpack_public_path__ + "static/media/usdt.2499bf87.svg";